import apiClient from './axiosConfig'; // Import apiClient
import { API_ENDPOINTS } from '../constants';

const fetchClients = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.CLIENTS); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching clients:', error);
    throw error;
  }
};

export { fetchClients };